(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/prolongation/views/bets.js') >= 0) return;  svs.modules.push('/components/numbergames/prolongation/views/bets.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.numbergames=_svs.numbergames||{};
_svs.numbergames.prolongation=_svs.numbergames.prolongation||{};
_svs.numbergames.prolongation.templates=_svs.numbergames.prolongation.templates||{};
svs.numbergames.prolongation.templates.bets = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"js-prolongation-bets-content prolongation-bets-content prolongation-bets-content-"
    + container.escapeExpression((lookupProperty(helpers,"brandingClass")||(depth0 && lookupProperty(depth0,"brandingClass"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"productId") : depth0),{"name":"brandingClass","hash":{},"data":data,"loc":{"start":{"line":1,"column":93},"end":{"line":1,"column":120}}}))
    + "\">\n  <div class=\"prolongation-bet-region\"></div>\n  <div class=\"prolongation-joker-region\"></div>\n</div>\n";
},"useData":true});
Handlebars.partials['components-numbergames-prolongation-bets'] = svs.numbergames.prolongation.templates.bets;
})(svs, Handlebars);


 })(window);